<ms-scroll-adapter>
    <div class="market-groups-header">
        @for (tab of marketTabs; track trackItem($index, tab)) {
            <div class="market-tab" [class.active]="tab.id === selectedMarketTab.id" (click)="tabSelected($event, tab)">
                <span class="title">{{ tab.name }}</span>
            </div>
        }
    </div>
</ms-scroll-adapter>
